namespace RioERP.Reports {
    export interface InvoiceDetailedReportRow {
        Id?: number;
        InvoiceDate?: string;
        OrderDate?: string;
        Invoicenumber?: string;
        EPaymentType?: RioErp.Web.Enums.PaymentType;
        Views?: Web.Enums.EOpens;
        Validity?: Web.Enums.EValidity;
        CustomerName?: string;
        EInvoiceTo?: number;
        FranchiseeName?: string;
        ProductName?: string;
        TaxCategoryName?: string;
        InvoiceCompanyId?: number;
        OrderNumber?: string;
        SpecificationName?: string;
        Quantity?: number;
        OrderProductBillingItemsId?: number;
        FranchiseeDiscountAmount?: number;
        City?: string;
        FranchiseeId?: number;
        CustomerId?: number;
        ProductId?: number;
        HsnCode?: string;
        InvoiceId?: number;
        EPaymentStatus?: Web.Enums.PaymentStatus;
        DiscountAmount?: number;
        Amount?: number;
        TotalTax?: number;
        OrderDiscount?: number;
        ProductDiscount?: number;
        Total?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        CgstRate?: number;
        CgstAmount?: number;
        SgstRate?: number;
        SgstAmount?: number;
        IgstRate?: number;
        IgstAmount?: number;
        StateName?: string;
        Gstin?: string;
        TransactionId?: string;
    }

    export namespace InvoiceDetailedReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Invoicenumber';
        export const localTextPrefix = 'Reports.InvoiceDetailedReport';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            InvoiceDate = "InvoiceDate",
            OrderDate = "OrderDate",
            Invoicenumber = "Invoicenumber",
            EPaymentType = "EPaymentType",
            Views = "Views",
            Validity = "Validity",
            CustomerName = "CustomerName",
            EInvoiceTo = "EInvoiceTo",
            FranchiseeName = "FranchiseeName",
            ProductName = "ProductName",
            TaxCategoryName = "TaxCategoryName",
            InvoiceCompanyId = "InvoiceCompanyId",
            OrderNumber = "OrderNumber",
            SpecificationName = "SpecificationName",
            Quantity = "Quantity",
            OrderProductBillingItemsId = "OrderProductBillingItemsId",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            City = "City",
            FranchiseeId = "FranchiseeId",
            CustomerId = "CustomerId",
            ProductId = "ProductId",
            HsnCode = "HsnCode",
            InvoiceId = "InvoiceId",
            EPaymentStatus = "EPaymentStatus",
            DiscountAmount = "DiscountAmount",
            Amount = "Amount",
            TotalTax = "TotalTax",
            OrderDiscount = "OrderDiscount",
            ProductDiscount = "ProductDiscount",
            Total = "Total",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            CgstRate = "CgstRate",
            CgstAmount = "CgstAmount",
            SgstRate = "SgstRate",
            SgstAmount = "SgstAmount",
            IgstRate = "IgstRate",
            IgstAmount = "IgstAmount",
            StateName = "StateName",
            Gstin = "Gstin",
            TransactionId = "TransactionId"
        }
    }
}
